// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast-container[data-v-2d9d5ff8]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#35495e;color:#fff;padding:10px 15px;border-radius:4px;z-index:1000}.toast-fade-enter-active[data-v-2d9d5ff8],.toast-fade-leave-active[data-v-2d9d5ff8]{transition:opacity .5s}.toast-fade-enter[data-v-2d9d5ff8],.toast-fade-leave-to[data-v-2d9d5ff8]{opacity:0}", ""]);
// Exports
module.exports = exports;
